export interface FaqItem {
  id: number;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    q: '看料站的速报多久更新一次？',
    a: '看料站以"滚动更新"为核心理念，速报频道会随着热点事件的发酵持续补充内容，越重要的节点更新越密集。你可以在"实时速报"板块按频道筛选，快速定位自己关注的领域，避免在海量信息里漏掉关键更新。',
  },
  {
    id: 2,
    q: '"实时速报"里的频道都可以点吗？怎么筛选？',
    a: '可以。实时速报板块顶部提供了娱乐、影视、综艺、社会、资讯、热梗等频道切换按钮，点击某个频道就会只展示该领域的速报内容，切换到"全部"则会看到当前完整的滚动信息流，方便你按需追更。',
  },
  {
    id: 3,
    q: '热榜排名的热度是怎么算出来的？',
    a: '全网热榜综合了话题在公开平台上的讨论量、增速、传播深度与停留时长等维度，通过统一的算法归一化后生成热度值与实时排名。榜单会随事件发酵动态变化，帮助你一眼看出今天真正"滚烫"的内容。',
  },
  {
    id: 4,
    q: '头条走马灯里一直滚动的是什么内容？',
    a: '首屏顶部的走马灯是一条"头条速递"，轮播展示当下正在快速升温、值得第一时间关注的核心话题。鼠标悬停会暂停滚动，方便你从容阅读当前某一条速报的核心信息。',
  },
  {
    id: 5,
    q: '同一个热点会跟进到什么时候？',
    a: '对于持续发酵的热点，我们会沿着时间线持续更新事件的进展脉络，从最初的信息释放、多方回应，到结论与讨论沉淀，尽量完整还原每个关键节点，方便你回顾整条事件的演进过程。',
  },
  {
    id: 6,
    q: '如何联系看料站，或对某条内容反馈意见？',
    a: '欢迎通过页脚的邮箱与我们交流，无论是线索建议还是内容反馈都能直接发送。我们珍视每一位读者对信息准确度与及时性的建议，并会据此不断优化速报的覆盖面与更新节奏。',
  },
];